module.exports = __webpack_public_path__ + "img/symbol_3.b5d6629b.png";